export default __webpack_public_path__ + "static/media/nose.3c8ba269.svg";